import { SiteList } from 'containers';
import { FC } from 'react';

import SectionStyled from './styles';

const ApprovedSites: FC = () => {
  return (
    <SectionStyled>
      <SiteList />
    </SectionStyled>
  );
};

export default ApprovedSites;
